/* Buon Cibo site chrome, shared by every page: the live open/closed pill in the
 * footer and the tone of the email signup above it. Concept pages swap their footer
 * in after load, so this watches the document and re-binds when chrome appears. */
(function () {
  'use strict';

  /* ---------- Live open / closed ---------- */
  // Evaluated on the store's own clock so a visitor in another timezone still
  // sees Buon Cibo's hours, not their own.
  function storeClock(timeZone) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone || 'America/Los_Angeles',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
      }).formatToParts(new Date());
      var hour = 0;
      var minute = 0;
      parts.forEach(function (part) {
        if (part.type === 'hour') hour = Number(part.value);
        if (part.type === 'minute') minute = Number(part.value);
      });
      if (hour === 24) hour = 0;
      return hour + minute / 60;
    } catch (error) {
      var now = new Date();
      return now.getHours() + now.getMinutes() / 60;
    }
  }

  function hourLabel(hour) {
    var suffix = hour >= 12 && hour < 24 ? 'PM' : 'AM';
    var display = hour % 12;
    if (display === 0) display = 12;
    return display + ' ' + suffix;
  }

  // Fills the status pill. The schedule beside it is plain markup, so the hours
  // stay readable (and crawlable) without script; the pill only appears once live.
  function renderHours() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bc-hours]'), function (root) {
      var openHour = Number(root.getAttribute('data-bc-open-hour'));
      var closeHour = Number(root.getAttribute('data-bc-close-hour'));
      if (!isFinite(openHour)) openHour = 9;
      if (!isFinite(closeHour)) closeHour = 20;
      var status = root.querySelector('[data-bc-hours-status]');
      if (!status) return;
      var value = storeClock(root.getAttribute('data-bc-tz'));
      var isOpen = value >= openHour && value < closeHour;
      if (root.getAttribute('data-bc-open') !== String(isOpen)) root.setAttribute('data-bc-open', String(isOpen));

      var text;
      if (isOpen) {
        var hoursLeft = closeHour - value;
        text = hoursLeft <= 1
          ? 'Open · closing in ' + Math.max(1, Math.round(hoursLeft * 60)) + ' min'
          : 'We’re open until ' + hourLabel(closeHour);
      } else if (value < openHour) {
        text = 'Closed · opens at ' + hourLabel(openHour);
      } else {
        text = 'Closed · opens tomorrow at ' + hourLabel(openHour);
      }
      if (status.textContent !== text) status.textContent = text;
      if (!root.classList.contains('is-live')) root.classList.add('is-live');
    });
  }

  /* ---------- Email signup tone ---------- */
  function alpha(color) {
    var match = color && color.match(/[\d.]+/g);
    return match && match.length > 3 ? parseFloat(match[3]) : 1;
  }

  function luminance(color) {
    var match = color.match(/[\d.]+/g);
    if (!match) return 1;
    var channel = function (value) {
      value /= 255;
      return value <= 0.04045 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * channel(+match[0]) + 0.7152 * channel(+match[1]) + 0.0722 * channel(+match[2]);
  }

  // The visible surface a node presents at its bottom edge: its own background,
  // or its last opaque descendant's (wrappers like <main> are transparent).
  function surfaceOf(node) {
    var depth = 0;
    while (node && depth < 6) {
      var background = window.getComputedStyle(node).backgroundColor;
      if (background && alpha(background) > 0.85) return background;
      node = node.lastElementChild;
      depth += 1;
    }
    return 'rgb(255, 255, 255)';
  }

  function previousVisible(node) {
    var previous = node.previousElementSibling;
    while (previous && (previous.offsetHeight < 40 || window.getComputedStyle(previous).display === 'none')) {
      previous = previous.previousElementSibling;
    }
    return previous;
  }

  function toneNewsletters() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bc-newsletter]'), function (block) {
      var tone = block.getAttribute('data-bc-tone') || 'auto';
      var resolved = tone;
      if (tone === 'auto') {
        var previous = previousVisible(block);
        var lum = previous ? luminance(surfaceOf(previous)) : 1;
        // Dark or pure white above: a wash card reads as its own module.
        // Tinted-light above: a white card with a border keeps it distinct.
        resolved = lum < 0.35 || lum > 0.95 ? 'wash' : 'white';
      }
      if (block.getAttribute('data-bc-tone-resolved') !== resolved) block.setAttribute('data-bc-tone-resolved', resolved);
    });
  }

  function bindNewsletterForms() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bc-newsletter] form'), function (form) {
      if (form.dataset.bcNewsBound === 'true') return;
      form.dataset.bcNewsBound = 'true';
      form.addEventListener('submit', function () {
        if (!form.checkValidity()) return;
        var button = form.querySelector('.bc-news__button');
        if (!button) return;
        button.disabled = true;
        button.textContent = 'Joining…';
      });
    });
  }

  function connectReviewNavigation() {
    document.querySelectorAll('header nav').forEach(function (nav) {
      if (!nav.querySelector('a[href="/pages/menu"]')) return;
      if (nav.querySelector('a[href="/pages/reviews"]')) return;
      var about = nav.querySelector('a[href="/pages/about"]');
      var link = document.createElement('a');
      link.href = '/pages/reviews';
      link.textContent = 'Reviews';
      if (window.location.pathname.replace(/\/$/, '') === '/pages/reviews') link.setAttribute('aria-current', 'page');
      if (about && about.parentNode === nav) about.insertAdjacentElement('afterend', link);
      else nav.appendChild(link);
    });
  }

  /* ---------- Wiring ---------- */
  var scheduled = false;
  function run() {
    if (scheduled) return;
    scheduled = true;
    // A timer, not requestAnimationFrame: rAF is paused in background tabs, which
    // left the pill on its static fallback until the tab was focused.
    window.setTimeout(function () {
      scheduled = false;
      connectReviewNavigation();
      renderHours();
      toneNewsletters();
      bindNewsletterForms();
    }, 30);
  }

  function start() {
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
    window.setInterval(renderHours, 60000);
    window.addEventListener('resize', run);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* ---------------------------------------------------------------------------
   Film dialog.

   Any `<button data-bc-film="<url>">` anywhere on the site opens that video in a
   dialog. The point is that nothing is downloaded until somebody asks: the card
   carries a photograph and a play button, and the <video> element does not exist
   until the button is pressed. A 90-second film on the homepage would otherwise
   cost every visitor the bytes, and most visitors never press play.

   One dialog is built on first use and reused, so a page with five play buttons
   still has one player.
   --------------------------------------------------------------------------- */
(function () {
  var dlg = null, video = null, opener = null;

  function build() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'bc-film';
    dlg.innerHTML =
      '<button class="bc-film__close" type="button" aria-label="Close the video">&#10005;</button>' +
      '<video class="bc-film__video" controls playsinline preload="auto"></video>';
    document.body.appendChild(dlg);
    video = dlg.querySelector('video');

    dlg.querySelector('.bc-film__close').addEventListener('click', function () { dlg.close(); });

    // Clicking the backdrop closes it. The dialog itself is the click target for
    // its own backdrop, so anything inside it must not count.
    dlg.addEventListener('click', function (ev) { if (ev.target === dlg) dlg.close(); });

    // Escape, handled here rather than left to the browser. A modal <dialog> is
    // supposed to close itself on Escape, but with a playing <video> inside it the
    // key does not always reach the dialog's own close watcher - measured, not
    // assumed. Closing it explicitly costs one listener and removes the doubt.
    dlg.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' || ev.key === 'Esc') {
        ev.preventDefault();
        dlg.close();
      }
    });

    // Stop playback and drop the source on close, so a closed dialog is not still
    // streaming in the background.
    dlg.addEventListener('close', function () {
      try { video.pause(); } catch (e) {}
      video.removeAttribute('src');
      video.load();
      if (opener && document.contains(opener)) opener.focus();
      opener = null;
    });
    return dlg;
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-bc-film]') : null;
    if (!btn) return;
    var src = btn.getAttribute('data-bc-film');
    if (!src) return;
    ev.preventDefault();
    opener = btn;
    build();
    var poster = btn.getAttribute('data-bc-film-poster');
    if (poster) video.setAttribute('poster', poster); else video.removeAttribute('poster');
    var label = btn.getAttribute('data-bc-film-label');
    video.setAttribute('aria-label', label || 'Video');
    video.src = src;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    // Autoplay here is a response to a click, so it is not motion the visitor did
    // not ask for - and it is allowed with sound for the same reason.
    var p = video.play();
    if (p && p.catch) p.catch(function () { /* the controls are right there */ });
  });
})();
